<template>
    <div class="apprentice-simple-card">
        <div class="linked-groups">
            <!--            <h2 class="title">Gekoppelde klassen</h2>-->

            <design-2021-apprentice-data-table
                class="slu-cohort-las-groups"
                :items="tableData"
                :fields="groupFields">
                <template #options>
                    <b-button
                        class="btn-add"
                        v-b-modal="'class-link-modal'"
                        variant="primary">
                        {{ $t('slu_dashboard.add_classes') }}
                    </b-button>
                </template>

                <template v-slot:cell(action)="data">
                    <b-button
                        class="btn-remove btn-remove-las-group"
                        variant="danger-icon-only"
                        @click="deleteLasGroup(data.item)">
                    </b-button>
                </template>
            </design-2021-apprentice-data-table>
        </div>

        <design-2021-slu-cohort-link-class-modal-component
            :slu-cohort-in="sluCohortIn"
            :las-groups-in="lasGroupsIn"
            :las-main-groups-in="lasMainGroupsIn"
            @updateCohort="updateCohort($event)"
            ref="class-link-modal">
        </design-2021-slu-cohort-link-class-modal-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-slu-cohort-las-groups-tab-component',
    props: ['lasMainGroupsIn', 'lasGroupsIn', 'sluCohortIn'],
    data() {
        return {
            sluCohort: this.sluCohortIn,
            groupFields: [
                {
                    key: 'name',
                    label: this.$t('common.name'),
                },
                {
                    key: 'type',
                    label: 'Type',
                },
                {
                    key: 'action',
                    label: this.$t('common.actions'),
                },
            ],
            storageName: `slu-cohort-${this.$authUser.id}-${this.sluCohortIn.id}-tab`,
        };
    },
    computed: {
        tableData() {
            let groups = this.sluCohort.las_groups.map((group) => {
                group.type = this.$t('slu_dashboard.lesson_group');
                return group;
            });
            let mainGroups = this.sluCohort.las_main_groups.map((group) => {
                group.type = this.$t('slu_dashboard.main_group');
                return group;
            });
            return groups.concat(mainGroups);
        },
    },

    methods: {
        deleteLasGroup(group) {
            this.alert
                .confirm(
                    this.$t('slu_dashboard.delete_group'),
                    this.$t('slu_dashboard.are_you_sure_you_want_to_delete_this_group'),
                )
                .then((confirm) => {
                    if (!confirm) {
                        return;
                    }
                    this.alert.saving();
                    let type;
                    if (group.type === this.$t('slu_dashboard.lesson_group')) {
                        type = 'lasGroup';
                    } else {
                        type = 'lasMainGroup';
                    }
                    let data = {
                        id: group.id,
                        type: type,
                    };
                    this.axios
                        .delete(
                            this.routes.sluCohortDeleteLasGroup(
                                this.sluCohort.slu_course_id,
                                this.sluCohort.id,
                                type,
                                group.id,
                            ),
                        )
                        .then(
                            (response) => {
                                this.updateCohort(response.data);
                                this.alert.success();
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                });
        },
        updateCohort(sluCohort) {
            this.sluCohort = sluCohort;
            this.$refs['class-link-modal'].sluCohort = sluCohort;
            this.$emit('updateCohort', sluCohort);
        },
    },

    mounted() {
        if (localStorage.getItem(this.storageName)) {
            const tabSettings = JSON.parse(localStorage.getItem(this.storageName));
            if (tabSettings.show_modal) {
                if (this.lasGroupsIn.length + this.lasMainGroupsIn.length !== this.tableData.length) {
                    this.$bvModal.show('class-link-modal');
                    tabSettings.show_modal = false;
                    localStorage.setItem(this.storageName, JSON.stringify(tabSettings));
                }
            }
        }
    },
};
</script>

<style scoped lang="scss"></style>
